import Container from "../../components/ui/Container";
import TermsAndCondition from "../../components/TermsAndCondition/TermsAndCondition";

const TermsAndConditionPage: React.FC = () => {
    return (
         <Container>
            <TermsAndCondition/>
        </Container>
    );
}
export default TermsAndConditionPage;